import { RouteComponentProps } from 'src/router/types';

export type RouteProps<T = {}> = RouteComponentProps<
  T & {
    projectKey: string;
    workspaceSlug: string;
  }
>;

export enum PROJECT_EVENT_SOURCES {
  PROJECT_REPOSITORIES_SCREEN = 'projectRepositoriesScreen',
  ADD_REPOSITORIES_MODAL = 'addRepositoriesModal',
  PROJECT_SETTINGS_DEFAULT_REVIEWERS_SCREEN = 'projectSettingsDefaultReviewersScreen',
  PROJECT_SETTINGS_MERGE_STRATEGIES_SCREEN = 'projectSettingsMergeStrategiesScreen',
  PROJECT_SETTINGS_BRANCHING_MODEL_SCREEN = 'projectSettingsBranchingModelScreen',
  PROJECT_SETTINGS_PERMISSIONS_SCREEN = 'projectSettingsPermissionsScreen',
  PROJECT_DETAILS_SCREEN = 'projectDetailsScreen',
  DELETE_PROJECT_MODAL = 'deleteProjectModal',
  UPDATE_PROJECT_AVATAR_MODAL = 'updateProjectAvatarModal',
  SETTINGS_ACCESS_KEYS_SCREEN = 'projectSettingsAccessKeysScreen',
  SETTINGS_CREATE_ACCESS_KEY_MODAL = 'projectSettingsAddSshKeyModal',
  SETTINGS_DELETE_ACCESS_KEY_MODAL = 'projectSettingsDeleteSshKeyModal',
  SETTINGS_VIEW_ACCESS_KEY_MODAL = 'projectSettingsViewSshKeyModal',
  SETTINGS_ADD_DEFAULT_REVIEWERS_MODAL = 'projectSettingsAddReviewersModal',
  UNKNOWN = 'unknown',
}
